import { AgentDetailAccessSourceEnum, UserOfferSourceAnalysisItemSourceEnum } from "@/api/generated";

// URL遷移用のSource
export const AGENT_DETAIL_URL_SOURCE = {
  TOP: AgentDetailAccessSourceEnum.Top, // トップ画面から
  AGENT_SEARCH: AgentDetailAccessSourceEnum.AgentSearch, // エージェント検索ページ（検索前）から
  SEARCH_RESULT: AgentDetailAccessSourceEnum.SearchResult, // エージェント検索結果（検索後）から
  LIMITED_PROPERTY: AgentDetailAccessSourceEnum.LimitedProperty, // 非公開物件カードから
  LEARNING_ARTICLE: AgentDetailAccessSourceEnum.LearningArticle, // 学習記事から
  SIMILAR_AGENT: AgentDetailAccessSourceEnum.SimilarAgent, // 追加マッチング候補から
  DIAGNOSIS_COMPATIBILITY_AGENTS: AgentDetailAccessSourceEnum.DiagnosisCompatibilityAgents, // 登録フロー相性画面から
} as const;

// API送信用のSource
export const USER_OFFER_SOURCE = {
  // 直接ボタン押下
  TOP_DIRECT: UserOfferSourceAnalysisItemSourceEnum.Top, // トップ画面→「話を聞いてみる」直接
  // 検索ページを絞り込みなしで開いた一覧（マッチ度順）→「話を聞いてみる」直接。
  // 名残で「なんでもサポート」由来の値だが、当該コンテンツは削除済みで、現在は
  // source クエリ無し・tags 無しで /agent_search を開いたときのフォールバックとして付く
  AGENT_SEARCH_DIRECT: UserOfferSourceAnalysisItemSourceEnum.AgentSearch,
  SEARCH_RESULT_DIRECT: UserOfferSourceAnalysisItemSourceEnum.SearchResult, // 検索結果→「話を聞いてみる」直接（検索後）
  LEARNING_ARTICLE_DIRECT: UserOfferSourceAnalysisItemSourceEnum.LearningArticle, // 学習記事→エージェント検索→「話を聞いてみる」直接

  // 詳細画面経由
  TOP_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.TopViaDetail, // トップ画面→詳細→「話を聞いてみる」
  AGENT_SEARCH_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.AgentSearchViaDetail, // 検索ページ（絞込なし）→詳細→「話を聞いてみる」
  SEARCH_RESULT_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.SearchResultViaDetail, // 検索結果（検索後）→詳細→「話を聞いてみる」
  LIMITED_PROPERTY_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.LimitedPropertyViaDetail, // 非公開物件→詳細→「話を聞いてみる」
  LEARNING_ARTICLE_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.LearningArticleViaDetail, // 学習記事→エージェント詳細→「話を聞いてみる」
  SIMILAR_AGENT_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.SimilarAgentViaDetail, // 追加マッチング候補→詳細→「話を聞いてみる」
  DIAGNOSIS_COMPATIBILITY_AGENTS_VIA_DETAIL: UserOfferSourceAnalysisItemSourceEnum.DiagnosisCompatibilityAgentsViaDetail, // 登録フロー相性画面→詳細→「話を聞いてみる」
} as const;

export type AgentDetailUrlSource = (typeof AGENT_DETAIL_URL_SOURCE)[keyof typeof AGENT_DETAIL_URL_SOURCE];
export type UserOfferSource = (typeof USER_OFFER_SOURCE)[keyof typeof USER_OFFER_SOURCE];
